import { CHAT_INBOUND_READ_RECEIPT_FAILED_REASONS } from 'cpool-constants';
import { z } from 'zod';

import { schemaChatInboundReadReceiptSharedPayload } from './schemaChatInboundReadReceiptSharedPayload';

export const schemaChatInboundReadReceiptFailedPayload = schemaChatInboundReadReceiptSharedPayload.extend({
    reason: z.nativeEnum(CHAT_INBOUND_READ_RECEIPT_FAILED_REASONS),
    reasonDetail: z.string().min(1),
});

export type Schema_ChatInboundReadReceiptFailedPayload = z.infer<typeof schemaChatInboundReadReceiptFailedPayload>;
